import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import * as fromRoot from '..';
import { SuccessAction, WarningAction, DangerAction, CloseAction } from '../alert/alert.actions';

@Injectable()
export class AlertService {
  constructor(
    private store: Store<fromRoot.State>,
  ) {}

  alerts() {
    return this.store.select(state => state.alert.alerts);
  }

  success(message: string) {
    this.store.dispatch(new SuccessAction(message));
  }

  warning(message: string) {
    this.store.dispatch(new WarningAction(message));
  }

  danger(message: string) {
    this.store.dispatch(new DangerAction(message));
  }

  close(index) {
    this.store.dispatch(new CloseAction(index));
  }
}



// WEBPACK FOOTER //
// /Users/shwld/project/shwld/home-counter/app_src/src/app/store/services/alert.service.ts